import { render } from "./GoodIcon.vue?vue&type=template&id=4a2b9020&scoped=true"
import script from "./GoodIcon.vue?vue&type=script&lang=js"
export * from "./GoodIcon.vue?vue&type=script&lang=js"

import "./GoodIcon.vue?vue&type=style&index=0&id=4a2b9020&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2b9020"]])

export default __exports__